import { jsx as _jsx } from "react/jsx-runtime";
import { Action } from './action';
import { useApiMutation } from '../../../../../../../infra/api';
import { endpoints } from '../../../../../network';
import PauseCampaignIcon from '../../../../icons/pause-campaign.svg';
import { CampaignAction } from '../../../../../../../types/engage-campaign';
import styles from './styles.module.scss';
export var PauseAction = function (_a) {
    var campaign = _a.campaign;
    var allowedActions = campaign.allowedActions;
    var pauseRecurringCampaign = useApiMutation({
        endpoint: endpoints.changeRecurringStateMutation,
    });
    var handlePauseClick = function () {
        pauseRecurringCampaign.mutate({
            campaignId: campaign.id,
            recurringState: 'stop',
        });
    };
    return (allowedActions.includes(CampaignAction.PAUSE) && (_jsx(Action, { name: "Pause", Icon: PauseCampaignIcon, onClick: handlePauseClick, id: "pause-campaign-".concat(campaign.id), className: styles['action-button'] })));
};
